import React, { useCallback } from 'react';
import styled from 'styled-components';
import { Hammer, Signpost, Shovel, Target, Settings, AudioWaveform } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const FeaturesSection = styled.section`
  font-family: Very Sans, Sans Serif;
`;

const FeaturesContainer = styled.div`
  max-width: 80%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 0 auto;
  padding: 0 24px;
  text-align: center;
  @media screen and (max-width: 756px) {
  padding-top: 25px;
  max-width: 100%;
  margin-bottom: 25px;
  
  }
`;



const FeaturesTitle = styled.h2`
  font-size: 48px;
  font-weight: 700;
  color: #8b5cf6;
  margin-bottom: 24px;
  font-family: Very Sans Headline, Sans Serif;
`;

const FeaturesDescription = styled.p`
  font-size: 18px;
  line-height: 1.6;
  color: rgba(255, 255, 255, 0.7);
  max-width: 600px;
  margin: 0 auto 80px;
`;

const FeaturesGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 24px;
  
  @media (max-width: 1024px) {
    grid-template-columns: repeat(2, 1fr);
  }
  
  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    width: 95%;
    margin: 0 auto;
    
  }
`;

const FeatureCard = styled.div`
  background: rgba(255, 255, 255, 0.025);
  border-radius: 12px;
  padding: 32px 24px;
  text-align: left;
  transition: all 0.3s ease;
  
  &.highlighted {
    background: #1e1e35;
    border: 1px solid #3a3a58;
  }
  
  &:hover {
    transform: translateY(-4px);
    background: rgba(59, 130, 246, 0.3);
  }

  @media screen and (max-width: 756px) {
  border: 1px solid rgba(255, 255, 255, 0.075);
  
  }
`;

const FeatureIconContainer = styled.div`
  width: 48px;
  height: 48px;
  background: rgba(59, 130, 246, 0.15);
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 24px;
  color: rgba(59, 130, 246, 1);
`;

const FeatureTitle = styled.h3`
  font-size: 20px;
  font-weight: 600;
  color: white;
  margin-bottom: 16px;
`;

const FeatureDescription = styled.p`
  font-size: 14px;
  line-height: 1.6;
  color: rgba(255, 255, 255, 0.6);
`;

const FeatureButton = styled.button`
  border: none;
  padding: 10px 15px;
  background: rgba(59, 130, 246, 0.25);
  border-radius: 5px;
  color: #ffffff;
  cursor: pointer;
  &:hover {
    background: rgba(59,130, 246, 1)
    }
  `
  

const FeatureButtonRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  gap: 10px;
  `

const Features = () => {

  const Navigate = useNavigate();

  const NavigateToValidarorApp = () => {
    Navigate("/validatorapp");
  };

  const handleDownload = () => {
        window.open(
        "https://play.google.com/store/apps/details?id=com.HydrixApp",
        "_blank",
        'noopener, noreferrer'
        );
    };

    const handleDownloadios = () => {
        window.open(
        "https://apps.apple.com/app/id6753764380",
        "_blank",
        'noopener, noreferrer'
        );
    };

    const handleGoToTelegram = () => {
      window.open(
        "https://t.me/hydrixgemsbot",
        "_blank",
        "noopener, noreferrer"
      );
    };

    const handleNodeDownload = useCallback(() => {
    const downloadUrl = 'https://chainfree.info:5010/download/hydrix-node.apk';
    
    const link = document.createElement('a');
    link.href = downloadUrl;
    link.download = 'hydrix-node.apk';
    link.target = '_blank';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    
    console.log('🚀 Hydrix Node APK download initiated');
  }, []);

  const handleOpenWhitepaper = () => {
    window.open(
      "https://ornate-gecko-119471.netlify.app/",
      "_blank",
      "noopener,noreferrer"
    );
  };

  return (
    <FeaturesSection>
      <FeaturesContainer>
      

        
        <FeaturesGrid>
          

          <FeatureCard>
            <FeatureIconContainer>
              <Shovel size={24} />
            </FeatureIconContainer>
            <FeatureTitle>Miners</FeatureTitle>
            <FeatureDescription>
              Mine tokens on your mobile device or mine on Telegram
            </FeatureDescription>
            <FeatureButtonRow>
              <FeatureButton onClick={handleDownload}>Android</FeatureButton>
              <FeatureButton onClick={handleGoToTelegram}>Telegram</FeatureButton>
              <FeatureButton onClick={handleDownloadios}>ios</FeatureButton>
            </FeatureButtonRow>
          </FeatureCard>

          <FeatureCard>
            <FeatureIconContainer>
              <AudioWaveform size={24} />
            </FeatureIconContainer>
            <FeatureTitle>Participate</FeatureTitle>
            <FeatureDescription>
              Run a Mobile Hydrix Node or apply to become a trusted validator
            </FeatureDescription>
            <FeatureButtonRow>
              <FeatureButton onClick={NavigateToValidarorApp}>Apply</FeatureButton>
              <FeatureButton onClick={handleNodeDownload}>Nodes</FeatureButton>
            </FeatureButtonRow>
          </FeatureCard>

          <FeatureCard>
            <FeatureIconContainer>
              <Signpost size={24} />
            </FeatureIconContainer>
            <FeatureTitle>Explore</FeatureTitle>
            <FeatureDescription>
              Everything you need to know about Hydrix, all in one place
            </FeatureDescription>
            <FeatureButtonRow>
              <FeatureButton onClick={handleOpenWhitepaper}>Docs</FeatureButton>
            </FeatureButtonRow>
          </FeatureCard>
          <FeatureCard>
            <FeatureIconContainer>
              <Hammer size={24} />
            </FeatureIconContainer>
            <FeatureTitle>Build</FeatureTitle>
            <FeatureDescription>
              Search the basics of launching your project on Hydrix chain
            </FeatureDescription>
            <FeatureButtonRow>
              <FeatureButton onClick={handleOpenWhitepaper}>Docs</FeatureButton>
              <FeatureButton>Support</FeatureButton>
            </FeatureButtonRow>
          </FeatureCard>
        </FeaturesGrid>
      </FeaturesContainer>
    </FeaturesSection>
  );
};

export default Features;